import { resultIds } from '../containers/SearchPage/SearchPage.duck';
import {
  fetchBlog,
  fetchBlogs,
  fetchFaq,
  fetchHelpPages,
  fetchSeoCategory,
  fetchSeoPages,
  fetchTagsFilter,
} from '../util/api';
import { isArrayLength } from '../util/genericHelpers';
import { createImageVariantConfig } from '../util/sdkLoader';
import { addMarketplaceEntities } from './marketplaceData.duck';

export const FETCH_CATEGORIESS_SUCCESS = 'app/strapi/FETCH_CATEGORIESS_SUCCESS';
export const SEARCH_SEO_CATEGORY_REQUEST = 'app/strapi/SEARCH_SEO_CATEGORY_REQUEST';
export const SEARCH_HELP_PAGES_REQUEST = 'app/strapi/SEARCH_HELP_PAGES_REQUEST';
export const FETCH_HELP_PAGES_SUCCESS = 'app/strapi/FETCH_HELP_PAGES_SUCCESS';
export const SAVE_HOMEPAGE_SECTIONS = 'app/strapi/SAVE_HOMEPAGE_SECTIONS';
export const FETCH_SINGLE_CATEGORIESS_SUCCESS = 'app/strapi/FETCH_SINGLE_CATEGORIESS_SUCCESS';

export const SEARCH_BLOGS_REQUEST = 'app/strapi/SEARCH_BLOGS_REQUEST';
export const SEARCH_BLOGS_SUCCESS = 'app/strapi/SEARCH_BLOGS_SUCCESS';
export const SEARCH_BLOGS_ERROR = 'app/strapi/SEARCH_BLOGS_ERROR';
export const SEARCH_SINGLE_BLOGS_SUCCESS = 'app/strapi/SEARCH_SINGLE_BLOGS_SUCCESS';
export const SEARCH_LISTINGS_SUCCESS = 'app/strapi/SEARCH_LISTINGS_SUCCESS';

export const SEARCH_FAQ_REQUEST = 'app/strapi/SEARCH_FAQ_REQUEST';
export const FETCH_FAQ_SUCCESS = 'app/strapi/FETCH_FAQ_SUCCESS';
export const SEARCH_FAQ_ERROR = 'app/strapi/SEARCH_FAQ_ERROR';

// ================ Reducer ================ //

const initialState = {
  searchSeoCategoryInProgress: false,
  seoCategories: [],
  homepageSections: [],
  seoCategory: null,
  searchInProgress: false,
  fetchHelpPagesInProgress: false,
  helpPages: null,
  searchBlogsError: null,
  blogsData: [],
  currentPageResultIds: [],
  singleBlogData: null,
  fetchFaqInProgress: false,
  faqItems: [],
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_FAQ_REQUEST:
      return {
        ...state,
        fetchFaqInProgress: true,
      };
    case FETCH_FAQ_SUCCESS:
      return {
        ...state,
        fetchFaqInProgress: false,
        faqItems: payload,
      };
    case SEARCH_FAQ_ERROR:
      return {
        ...state,
        fetchFaqInProgress: false,
      };

    case SEARCH_SEO_CATEGORY_REQUEST:
      return {
        ...state,
        searchSeoCategoryInProgress: true,
      };
    case FETCH_CATEGORIESS_SUCCESS:
      return {
        ...state,
        searchSeoCategoryInProgress: false,
        seoCategories: payload,
      };
    case SEARCH_HELP_PAGES_REQUEST:
      return {
        ...state,
        fetchHelpPagesInProgress: true,
      };
    case FETCH_HELP_PAGES_SUCCESS:
      return {
        ...state,
        fetchHelpPagesInProgress: false,
        helpPages: payload,
      };
    case SEARCH_LISTINGS_SUCCESS:
      return {
        ...state,
        currentPageResultIds: resultIds(payload.data),
        pagination: payload.data.meta,
        searchInProgress: false,
        searchSeoCategoryInProgress: false,
      };
    case SAVE_HOMEPAGE_SECTIONS:
      return {
        ...state,
        homepageSections: payload,
      };
    case FETCH_SINGLE_CATEGORIESS_SUCCESS:
      return {
        ...state,
        seoCategory: payload,
      };
    case SEARCH_BLOGS_REQUEST:
      return {
        ...state,
        searchInProgress: true,
      };
    case SEARCH_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        blogsData: payload?.data?.blogs || [],
        blogTags: payload?.data?.filters || [],
      };
    case SEARCH_SINGLE_BLOGS_SUCCESS:
      return {
        ...state,
        searchInProgress: false,
        singleBlogData: payload?.data || [],
      };
    case SEARCH_BLOGS_ERROR:
      return { ...state, searchInProgress: false, searchBlogsError: true };
    default:
      return state;
  }
}

// ================ Selectors ================ //

export const fetchSeoPagesSelector = state => {
  return state.strapi.seoCategories;
};

export const getFaq = state => state.strapi.faqItems;
export const getFaqInProgress = state => state.strapi.fetchFaqInProgress;

export const getBlogsInProgress = state => state.strapi?.searchInProgress;
export const getBlogsSelector = state => state.strapi?.blogsData;
export const getBlogsTagsSelector = state => state.strapi?.blogTags;

export const getBlogSelector = state => state.strapi.singleBlogData;
export const getSeoCategory = state => state.strapi.seoCategory;
export const getSeoListings = state => state.strapi.currentPageResultIds;

export const getHelpPages = state => state.strapi.helpPages;
export const getHelpPagesInProgress = state => state.strapi.fetchHelpPagesInProgress;
export const searchCategoryInProgress = state => state.strapi.searchSeoCategoryInProgress;

// ================ Action creators ================ //

export const searchFaqRequest = () => ({ type: SEARCH_FAQ_REQUEST });
export const fetchFaqSuccess = payload => ({ type: FETCH_FAQ_SUCCESS, payload });
export const searchFaqError = () => ({ type: SEARCH_FAQ_ERROR });

export const fetchSingleSeoCategorySuccess = payload => ({
  type: FETCH_SINGLE_CATEGORIESS_SUCCESS,
  payload,
});

export const fetchSeoCategoriesSuccess = payload => ({
  type: FETCH_CATEGORIESS_SUCCESS,
  payload,
});

export const fetchHelpPagesSuccess = payload => ({
  type: FETCH_HELP_PAGES_SUCCESS,
  payload,
});

export const saveHomepageSections = payload => ({
  type: SAVE_HOMEPAGE_SECTIONS,
  payload,
});

export const searchBlogsRequest = () => ({
  type: SEARCH_BLOGS_REQUEST,
});

export const searchHelpPagesRequest = () => ({
  type: SEARCH_HELP_PAGES_REQUEST,
});
export const searchSeoCategoryRequest = () => ({
  type: SEARCH_SEO_CATEGORY_REQUEST,
});

export const searchBlogsSuccess = response => ({
  type: SEARCH_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchSingleBlogsSuccess = response => ({
  type: SEARCH_SINGLE_BLOGS_SUCCESS,
  payload: { data: response },
});

export const searchBlogsError = () => ({
  type: SEARCH_BLOGS_ERROR,
});

export const searchListingsSuccess = response => ({
  type: SEARCH_LISTINGS_SUCCESS,
  payload: { data: response.data },
});

// ================ Thunks ================ //

export const fetchSeoCategoryBySlug = params => async (dispatch, getState, sdk) => {
  const { config, ...rest } = params;
  dispatch(searchSeoCategoryRequest());
  try {
    const { category } = (await fetchSeoCategory({ ...rest })) || {};
    if (isArrayLength(category) && category[0]) {
      const url = category[0]?.attributes?.url;
      const urlParams = new URLSearchParams(url);
      const bounds = urlParams.get('bounds');
      const response = await sdk.listings.query({
        perPage: 6,
        ...(bounds ? { bounds } : {}),
        include: ['author', 'images'],
        'fields.listing': [
          'title',
          'geolocation',
          'price',
          'availabilityPlan',
          'publicData',
          'publicData.listingType',
          'publicData.transactionProcessAlias',
          'publicData.unitType',
          // These help rendering of 'purchase' listings,
          // when transitioning from search page to listing page
          'publicData.pickupEnabled',
          'publicData.shippingEnabled',
        ],
        'fields.user': ['profile.displayName', 'profile.abbreviatedName'],
        'fields.image': [
          'variants.scaled-small',
          'variants.scaled-medium',
          `variants.listing-card`,
          `variants.listing-card-2x`,
        ],
        ...createImageVariantConfig(`listing-card`, 400, 1),
        ...createImageVariantConfig(`listing-card-2x`, 800, 1),
        'limit.images': 1,
      });
      const listingFields = config?.listing?.listingFields;
      const sanitizeConfig = { listingFields };

      dispatch(addMarketplaceEntities(response, sanitizeConfig));
      dispatch(searchListingsSuccess(response));
      dispatch(fetchSingleSeoCategorySuccess(category[0]));
    }
  } catch (error) {
    console.log(error, 'Error while fetching seo category');
  }
};

export const fetchSeoCategories = () => async (dispatch, getState, sdk) => {
  dispatch(searchSeoCategoryRequest());
  try {
    const { categories = {} } = (await fetchSeoPages({})) || {};
    const filteredCategories = isArrayLength(categories)
      ? categories.filter((v, i, a) => a?.findIndex(v2 => v2?.id === v?.id) === i)
      : [];
    dispatch(fetchSeoCategoriesSuccess(filteredCategories));
  } catch (error) {
    console.log(error, 'Error while fetching seo categories');
  }
};

export const fetchStrapiHelpPages = () => async (dispatch, getState, sdk) => {
  dispatch(searchHelpPagesRequest());
  try {
    const { content = {} } = (await fetchHelpPages({})) || {};
    dispatch(fetchHelpPagesSuccess(content));
  } catch (error) {
    console.log(error, 'Error while fetching help pages');
  }
};

export const fetchSingleBlog = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());
  try {
    const response = await fetchBlog({ ...params });
    const tagsResponse = await fetchTagsFilter({});
    dispatch(searchSingleBlogsSuccess(response?.blog));
    dispatch(
      searchBlogsSuccess({
        filters: tagsResponse ? tagsResponse?.tags : [],
      })
    );
    return response;
  } catch (error) {
    dispatch(searchBlogsError());
    console.log(error, 'Error while fetching seo categories');
  }
};

export const fetchAllBlogs = params => async (dispatch, getState, sdk) => {
  dispatch(searchBlogsRequest());

  try {
    let blogsResponse, tagsResponse;

    // Fetch blogs
    blogsResponse = await fetchBlogs({ ...params });
    tagsResponse = await fetchTagsFilter({});
    dispatch(
      searchBlogsSuccess({
        blogs: blogsResponse?.blogs,
        filters: tagsResponse ? tagsResponse?.tags : [],
      })
    );
    return blogsResponse?.blogs;
  } catch (error) {
    dispatch(searchBlogsError());
  }
};

export const fetchAllFaq = params => async (dispatch, getState, sdk) => {
  dispatch(searchFaqRequest());
  try {
    const { faqs = [] } = (await fetchFaq(params || {})) || {};
    dispatch(fetchFaqSuccess(faqs));
    return faqs;
  } catch (e) {
    dispatch(searchFaqError());
    console.log(e, 'Error while fetching FAQ');
  }
};
